/**
 * LoadingSpinner Component
 * 
 * Simple loading spinner for async operations
 */

export default function LoadingSpinner({ size = 'md', text = 'Loading...' }) {
  const sizes = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4',
    xl: 'h-16 w-16 border-4'
  };

  const spinnerClass = sizes[size] || sizes.md;

  return (
    <div className="flex flex-col items-center justify-center space-y-3 py-8">
      <div
        className={`${spinnerClass} border-blue-600 border-t-transparent rounded-full animate-spin`}
        role="status"
        aria-label="Loading"
      />
      {text && (
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {text}
        </p>
      )}
    </div>
  );
}
